/**
 * Shared functionality for loading high quality versions of images.
 */
(function($, document, window) {
    'use strict';

    $(window).on('load', function() {
        // Add svg with blur effect to body (needed to be able to blur images inside SVGs).
        var $svg = $('<svg style="position: absolute; width:0; height:0; left: -10px; top: -10px" ><defs><filter id="lazyLoad-1"><feGaussianBlur stdDeviation="10" /></filter></defs></svg>');
        $svg.appendTo($('body'));

        loadHQImages();

        if ($('body').hasClass('not-logged-in')) {
            // Functionality when user is not logged in
        }

        if ($('body').hasClass('logged-in')) {
            // Functionality when user is logged in
            $(document).on('cms.ready', function() {
                loadHQImages();

                $(document).on('widgetImages.update', function() {
                    loadHQImages();
                });
            });
        }
    });

    function loadHQImages() {
        // Initially images will always load in their lowest quality
        // This loads the "high quality" versions.
        loadHQBackgrounds();

        loadHQSVGImages();

        var $images = $('img');
        $images.each(function(i, elm) {
            var $elm = $(elm);
            if($elm.parents('picture').length > 0) { return $elm.removeClass('lazy-loading'); }
            var url = $elm.attr('src');

            if(!validUrl(url)) { return $elm.removeClass('lazy-loading'); }
            if(url.indexOf('opt=true') >= 0) { return $elm.removeClass('lazy-loading'); }

            var replace = url.indexOf('placeholders');
            if(replace > -1) {
                url = url.replace('placeholders/', 'images/');
            }

            url += (url.indexOf('?') < 0 ? '?' : '&') + 'opt=true';

            $elm.addClass('lazy-loading');
            loadImage(url, function() {
                $elm.attr('src', url);

                setTimeout(function() {
                    $elm.removeClass('lazy-loading');
                }, 100);
            });
        });
    }

    function loadHQBackgrounds() {
        // Those sections do not have the .cover-bg class.
        var $background_images = $('.cover-bg, .lazy-bg');
        $background_images.each(function(i, elm) {
            var urlstr = elm.style['background-image'];

            var url = parseBackgroundURL(urlstr);

            if(!validUrl(url)) { $(elm).removeClass('lazy-bg'); return; }
            if(url.indexOf('opt=true') >= 0) { $(elm).removeClass('lazy-bg'); return; }

            var replace = url.indexOf('placeholders');
            if(replace > -1) {
                url = url.replace('placeholders/', 'images/');
            }

            url += (url.indexOf('?') < 0 ? '?' : '&') + 'opt=true';

            // loadImage(url, function() {
            //     $(elm).removeClass('lazy-bg');
            // });
            elm.style['background-image'] = 'url("'+url+'"), ' + urlstr;
            setTimeout(function() {
                $(elm).removeClass('lazy-bg');
            }, 100);
        });
    }

    function loadHQSVGImages() {


        // Those sections do not have the .cover-bg class.
        var $svg_images = $('svg image');
        $svg_images.each(function(i, elm) {
            var $elm = $(elm);
            var url = $elm.attr('xlink:href');

            if(!validUrl(url)) { $elm.removeClass('lazy-bg'); return; }
            if(url.indexOf('opt=true') >= 0) { $elm.removeClass('lazy-bg'); return; }

            var replace = url.indexOf('placeholders');
            if(replace > -1) {
                url = url.replace('placeholders/', 'images/');
            }

            url += (url.indexOf('?') < 0 ? '?' : '&') + 'opt=true';

            $elm.addClass('lazy-bg');
            loadImage(url, function() {
                $elm.attr('xlink:href', url);
                setTimeout(function() {
                    $elm.removeClass('lazy-bg');
                }, 100);
            });
        });
    }

    function validUrl(url) {
        if(!url || url.trim().length < 7 || url.trim().length < 13) { return false; }//'images/'.length == 7, 'placeholders/'.length == 13

        if(url.indexOf(window.Contenda.basepath) == 0) {
            url = url.substring(window.Contenda.basepath.length);
        }

        if(url.substring(0,7) !== 'images/' && url.substring(0,13) !== 'placeholders/') { return false; }

        // Don't reload SVG files
        if(url.substr(url.indexOf('.') + 1, 3) === 'svg') { return false; }

        return true;
    }

    function parseBackgroundURL(urlstr) {
        if(!urlstr || urlstr.trim().length <= 7) { return false; }//url("").length == 7

        // Handle cases where url string is url(http://...) and not url("http://...")
        var hasTicks = urlstr.indexOf('("') > 0,
            beginIdx = hasTicks ? 5 : 4,
            endIdx = hasTicks ? urlstr.lastIndexOf('")') : urlstr.lastIndexOf(')');

        return urlstr.substring(beginIdx, endIdx);
    }

    // TODO: If image cannot load, the lazy-load class is never removed!
    function loadImage(url, callback) {
        if(!callback) { callback = function(){}; };

        var img = $('<img>').attr('src', url);

        // Has image already been loaded (is it in browser cache)?
        if(img.get(0).complete) {
            return callback();
        }
        return img.one('load', callback);
    }

})(jQuery, document, window);